<script setup lang="ts">
const { t } = useI18n();
const store = useMainStore();
const emailVerificationStore = useEmailVerificationStore();

const authorized = useCookie('authorized');

// TODO: не исчезает при получении соккет уведомления о добавлении Pro статуса
</script>

<template>
  <div
    v-if="
      (!store.isAuthorized && !authorized) ||
      store.user.isEmailVerified === false
    "
  >
    <Message class="getProFree__banner" severity="info" :closable="false">
      <div class="flex items-center justify-between flex-col sm:flex-row">
        <div>
          <h2 class="mt-0 mb-3 text-xl sm:text-2xl">
            {{ t('title') }}
          </h2>
          <i18n-t
            v-if="store.isAuthorized"
            keypath="benefits"
            tag="p"
            class="m-0"
          >
            <b>Pro</b>
          </i18n-t>
          <i18n-t v-else keypath="should_sign_in" tag="p" class="m-0">
            <b>Pro</b>
          </i18n-t>
        </div>
        <Button
          v-if="store.isAuthorized"
          @click="emailVerificationStore.sendVerificationEmail"
          :label="
            emailVerificationStore.isVerificationEmailSent
              ? t('repeat')
              : t('confirm')
          "
          rounded
          size="large"
          class="flex-shrink-0 mt-3 sm:mt-0 sm:ml-auto"
        />
        <Button
          v-else
          as="nuxt-link"
          :to="{ path: '/auth/sign-in', query: { verifyEmail: 'true' } }"
          :label="t('get')"
          rounded
          size="large"
          class="flex-shrink-0 mt-3 sm:mt-0 sm:ml-auto"
        />
      </div>
    </Message>

    <Message
      v-if="emailVerificationStore.isVerificationEmailSent"
      severity="info"
      class="mt-0 getProFree__notification"
      :closable="false"
    >
      {{ t('email_sent') }}
    </Message>
  </div>
</template>

<i18n>
en:
  title: We have a present for you!
  benefits: Verify your Email and get {0} week free!
  should_sign_in: Sign up and verify your Email and get {0} week free!
  get: Get
  email_sent: Email sent to your Email
  repeat: Repeat
  confirm: Confirm

ru:
  title: У нас для вас подарок!
  benefits: Подтвердите свой Email и получите неделю {0} бесплатно!
  should_sign_in: Зарегистрируйтесь и подтвердите свой Email и получите неделю {0} бесплатно!
  get: Получить
  email_sent: Письмо отправлено на ваш Email
  repeat: Повторить
  confirm: Подтвердить

de:
  title: Wir haben ein Geschenk für Sie!
  benefits: 'Bestätigen Sie Ihre E-Mail-Adresse und erhalten Sie eine Woche {0} kostenlos!'
  should_sign_in: 'Registrieren Sie sich, bestätigen Sie Ihre E-Mail-Adresse und erhalten Sie eine Woche {0} kostenlos!'
  get: Erhalten
  email_sent: Der Brief wurde an Ihre E-Mail-Adresse gesendet
  repeat: Wiederholen
  confirm: Bestätigen

es:
  title: ¡Tenemos un regalo para ti!
  benefits: ¡Confirma tu Email y obtén una semana {0} gratis!
  should_sign_in: Regístrate y confirma tu Email y consigue una semana {0} gratis!
  get: Conseguir
  email_sent: La carta ha sido enviada a su correo electrónico.
  repeat: Repetir
  confirm: Confirmar

fr:
  title: Nous avons un cadeau pour vous !
  benefits: Confirmez votre e-mail et obtenez une semaine de {0} gratuite !
  should_sign_in: Inscrivez-vous et confirmez votre Email et obtenez une semaine {0} gratuite !
  get: Obtenir
  email_sent: La lettre a été envoyée à votre Email
  repeat: Répéter
  confirm: Confirmer
</i18n>

<style lang="scss">
.getProFree {
  &__banner {
    border-radius: 16px;

    .p-message-icon {
      display: none;
    }

    .p-message-text {
      width: 100%;
    }
  }

  &__notification {
    border-radius: 16px;
  }
}
</style>
